import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import SearchFilterBox from "../../Components/SearchFilterBox";
import Table from "../../Components/Partners/Table";
import AddVendor from "../../Components/Partners/Add";
import { toast } from "react-toastify";
import EditPartner from "../../Components/Partners/EditPartner";
import DeletePartner from "../../Components/Partners/DeletePartner";
import SideModal from "../../Components/SideModal";
import { Save_Partners } from "../../Redux/actions";

const Partners = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const [key, setKey] = useState("");
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isAddPartner, setIsAddPartner] = useState(false);
  const [isEditPartner, setIsEditPartner] = useState(false);
  const [isDeletePartner, setIsDeletePartner] = useState(false);
  const dispatch = useDispatch()

  const fetchFunction = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
    const response = await axios.get(`${Config.apiUrl}/client/list/partners?${query}`, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess) {
      setApiData(res.partners);
      setIsFocused(true);
    }
  };

  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate({ searchQuery, filterType });
  }, []);

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    getListMutate({
      searchQuery: values.searchQuery,
      filterType: values.filterType,
    });
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "" });
  };

  //------- Add vendor -------
  const addPartnerFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/client/add/partner`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddPartnerSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      if (data?.data?.personalAndPartnerProperties)
        dispatch(Save_Partners(data?.data?.personalAndPartnerProperties));
      setIsAddPartner(false);
      getListMutate({ searchQuery: "", filterType: "" });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddPartnerError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addPartnerLoading, mutate: addPartnerMutate } = useMutation(
    addPartnerFunction,
    {
      onSuccess: onAddPartnerSuccess,
      onError: onAddPartnerError,
    }
  );
  const handleAddPartnerClose = () => {
    setIsAddPartner(false);
  };

  //------- Edit vendor -------
  const editPartnerFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/client/edit/partner`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditPartnerSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      if (data?.data?.personalAndPartnerProperties)
        dispatch(Save_Partners(data?.data?.personalAndPartnerProperties));
      setIsEditPartner(false);
      getListMutate({ searchQuery: "", filterType: "" });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditPartnerError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editPartnerLoading, mutate: editPartnerMutate } =
    useMutation(editPartnerFunction, {
      onSuccess: onEditPartnerSuccess,
      onError: onEditPartnerError,
    });
  const handleEditPartnerClose = () => {
    setIsEditPartner(false);
  };

  //------- Delete Partners -------
  const deleteVendorFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/vendor/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteVendorSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsDeletePartner(false);
      getListMutate({ searchQuery: "", filterType: "" });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const deleteVendorError = (data) => {
    setIsDeletePartner(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deletePartnerLoading, mutate: deletePartnerMutate } =
    useMutation(deleteVendorFunction, {
      onSuccess: deleteVendorSuccess,
      onError: deleteVendorError,
    });
  const handlePartnerClose = () => {
    setIsDeletePartner(false);
  };
  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Partners
          <Underline />
        </BoxTitle>
        <div className="flex space-x-4 md:ml-auto">
          <AddBtn
            type="button"
            onClick={() => {
              setKey(moment().unix());
              setIsAddPartner(true);
            }}
          >
            Add Partner
          </AddBtn>
        </div>
      </BoxHead>

      <SideModal
        isOpen={isAddPartner}
        onClose={() => setIsAddPartner(false)}
      >
        <AddVendor
          addPartnerMutate={addPartnerMutate}
          addPartnerLoading={addPartnerLoading}
          handleClose={handleAddPartnerClose}
        />
      </SideModal>

      <SideModal
        isOpen={isEditPartner}
        onClose={() => setIsEditPartner(false)}
      >
        <EditPartner
          editPartnerMutate={editPartnerMutate}
          editPartnerLoading={editPartnerLoading}
          handleClose={handleEditPartnerClose}
          selectedData={selectedData}
        />
      </SideModal>


      {isDeletePartner && (
        <DeletePartner
          setIsDeletePartner={setIsDeletePartner}
          isDeletePartner={isDeletePartner}
          deletePartnerLoading={deletePartnerLoading}
          deletePartnerMutate={deletePartnerMutate}
          selectedData={selectedData}
          handleClose={handlePartnerClose}
        />
      )}

      <FilterTableWrapper>
        <FilterWrapper>
          <div className="flex items-center justify-between w-full">
            <Text>
              Total records:{" "}
              <span className="font-semibold">
                {apiData?.length || 0}
              </span>
            </Text>
            <div className="flex ustify-end items-center ml-auto">
              <SearchFilterBox
                options={searchOptions}
                handleFilterChange={handleFilterChange}
                handleClearFilters={handleClearFilters}
              />
            </div>
          </div>
        </FilterWrapper>
        {!error && !isLoading && data && (
          <TableWrapper>
            <Table
              apiData={apiData || []}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              setIsEditPartner={setIsEditPartner}
              setIsDeletePartner={setIsDeletePartner}
            />
            {(!apiData || apiData.length === 0) && <NotFoundModel />}
          </TableWrapper>
        )}
      </FilterTableWrapper>

      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;
// const FilterWrapper = tw.div`flex w-full pb-4 lg:flex-row flex-col lg:gap-0 gap-4`;
const AddBtn = tw.button`whitespace-nowrap flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;

const Text = tw.p`text-gray-500 text-sm font-normal `;

export default Partners;
